import { useRabbitFestivalContext } from "../../../../hooks/festival-context";
import {
  FestivalEventBottomWrapper,
  FestivalEventBottomState,
  FestivalEventBottomButton,
} from "./style";
import { getEntryButtonText } from "../../../../../../../utils/tournament";
import { useRabbitFestivalReservation } from "../../hooks/use-festival-reservation";
import ReservationCancelPopup from "../../../../../MyReservation/component/isCancel";
import CompanyReservationPopup from "../../../../../CompanyReservation/component/ReservationPopup";
import ReservationStatusPopup from "../../../../../CompanyReservation/component/ReservationStatusPopup";
import { useMemo } from "react";

const RabbitFestivalEventBottom = () => {
  const { event, getEvent, eventId } = useRabbitFestivalContext();
  const {
    getReservationButtonText,
    handleClickStateButton,
    handleClickButton,
    canReservation,
    isReservation,
    isReservationCancel,
    setIsReservationCancel,
    handleCancel,
    isReservationPopup,
    setIsReservationPopup,
    isCurrentReservation,
    setIsCurrentReservation,
    reservationEnd,
  } = useRabbitFestivalReservation(eventId, event?.tournament);
  const currentReservations = useMemo(() => {
    if (!event?.tournament.current) return [];
    return event.tournament.current.map((item, i) => {
      return {
        order: (i + 1).toString(),
        customerName: item.nickName,
        id: item.id,
        route: item.route,
      };
    });
  }, [event]);

  const buttonOpen = () => {
    if (!event?.tournament.reservation) return true;
    if (event.tournament.isEnd) return true;
    if (reservationEnd()) return false;
    return canReservation();
  };

  return (
    <>
      {/* 예약 취소 팝업 */}
      {isReservationCancel && (
        <ReservationCancelPopup
          onClose={() => setIsReservationCancel(false)}
          handleCancel={() => {
            handleCancel();
            setTimeout(() => {
              getEvent();
            }, 100);
          }}
        />
      )}
      {/* 예약 팝업 */}
      {isReservationPopup && (
        <CompanyReservationPopup
          onClose={() => setIsReservationPopup(false)}
          getData={getEvent}
          reservationId={event?.tournament.reservation?.id || 0}
          keepSeed={event?.tournament.reservation?.keepSeed || 0}
          type={"reservation"}
          tournamentName={event?.tournament.title || ""}
        />
      )}
      {/* 예약자 목록 팝업 */}
      {isCurrentReservation && (
        <ReservationStatusPopup
          reservations={currentReservations}
          onClose={() => setIsCurrentReservation(false)}
          isOpen={isCurrentReservation}
        />
      )}
      <FestivalEventBottomWrapper>
        <FestivalEventBottomState onClick={handleClickStateButton}>
          <img src="/image-web/reservation/state_button.svg" alt="state" />
          <div className="count">{getEntryButtonText(event?.tournament)}</div>
        </FestivalEventBottomState>
        <FestivalEventBottomButton
          isOpen={buttonOpen()}
          isReservation={event?.tournament.isEnd ? false : isReservation}
          onClick={() => {
            if (isReservation) handleClickButton();
            if (buttonOpen()) handleClickButton();
          }}
        >
          {getReservationButtonText()}
        </FestivalEventBottomButton>
      </FestivalEventBottomWrapper>
    </>
  );
};

export default RabbitFestivalEventBottom;
